import { mapGetters, mapActions } from 'vuex'

import headers from './headers'
import {
  DisplaySwitchButton,
  HelpCircle,
  ProductTable
} from '@/components/items'
import { storageUtil } from '@/util'
import HoverPopNormal from '@/components/layouts/HoverPop/HoverPopNormal'

import DialogAlertError from '@/components/layouts/Dialogs/DialogAlert/DialogAlertError'

export default {
  components: {
    DisplaySwitchButton,
    HelpCircle,
    ProductTable,
    HoverPopNormal,
    DialogAlertError
  },
  props: {
    isEditPage: { default: false },

    isClientSelect: {
      type: Boolean,
      require: true,
      default: false
    },
    isRegist: {
      type: Boolean,
      default: false
    },
    selectCurrency: {
      type: Object,
      require: true,
      default: () => {}
    },
    search: {},

    historyProductMoves: {
      type: Array,
      require: false,
      default: () => []
    }
  },
  data: () => ({
    openPanelIndex: [],
    groupNames: [],
    pageProductList: [],
    headers: [],

    productList: [],
    productListData: [],

    errDialog: false
  }),
  async created() {
    await this.init()
  },
  methods: {
    ...mapActions('Product', ['getProductAndStockListFromApi']),
    ...mapGetters('Product', ['getProductAndStockListFromState']),

    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),

    notClientSelect() {
      alert(this.$t('sale.sale_select-customer'))
      // this.errDialog = true
    },

    async init() {
      this.headers = this.isEditPage ? headers.history : headers.register

      await this.createProductListData()
      this.setGroupNames()

      this.changeHistoryProductMoves(false)
    },
    getSupplierName(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier ? supplier.name : this.$t('common.common_unknown')
    },

    getSupplierIsEnabled(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier.isEnabled
    },

    async createProductListData() {
      const supplierId = null
      await this.getProductAndStockListFromApi({
        supplierId: supplierId,
        isHideUnusedProduct: 1
      })
      const productList = this.getProductAndStockListFromState().filter(
        (ele) => {
          const name = ele.nameJp + '' + ele.nameCn
          const nameFilter = this.search.keyword
            ? name.includes(this.search.keyword)
            : true

          const categoryFilter = this.search.category
            ? this.search.category === ele.categoryId
            : true

          return nameFilter && categoryFilter
        }
      )

      this.productList = productList

      await this.getSuppliersFromApi()
      this.pageProductList = productList
        .filter((ele) => {
          return this.getSupplierIsEnabled(ele.supplierId)
        })
        .map((ele, index) => {
          ele.supplierName = this.getSupplierName(ele.supplierId)
          return ele
        })

      const storageIdNameList = await storageUtil.getStorageIdNameList()
      this.productListData = productList.map((ele, index) => {
        const storage = this.getStorageProductStockAndMoving(
          storageIdNameList.data,
          ele
        )
        const order = this.getProductQuantity(ele.productPlanQuantityInfo, 2)
        const sales = this.getProductQuantity(ele.productPlanQuantityInfo, 1)

        const stock = {
          storage: storage,
          order: order ? '※注文済未出庫：' + order : '',
          sales: sales ? '※発注済未入庫：' + sales : ''
        }

        let history
        if (Object.keys(this.historyProductMoves).length) {
          history = this.historyProductMoves.find(
            (historyProduct) =>
              historyProduct.product.productId === ele.productId
          )
        }

        return {
          ...ele,
          productId: ele.productId,
          invalid: false,
          supplierId: ele.supplierId,
          stock: stock,
          count: history ? history.quantity : null,
          price: history ? history.price : null,
          amount: history ? history.quantity * history.price : null,
          exportSubjectFlg: history
            ? history.exportSubjectFlg
            : this.isPurchasePriceCurrencyIdJa(ele.purchasePriceCurrencyId)
        }
      })
    },

    getHistoryProduct(productId) {
      this.historyProductMoves.find(
        (ele) => ele.product.productId === productId
      )
    },

    setGroupNames() {
      const productListTmp = [...this.productList]

      this.groupNames = productListTmp
        .sort((a, b) => {
          if (a.supplierId < b.supplierId) return -1
          if (a.supplierId > b.supplierId) return 1
          return 0
        })
        .reduce((result, current) => {
          var element = result.find((p) => p.groupId === current.supplierId)
          if (!element) {
            result.push({
              groupId: current.supplierId,
              open: false,
              index: result.length
            })
          }
          return result
        }, [])
    },
    isOpenPanelOpen(id) {
      const group = this.groupNames.find((p) => p.groupId === id)
      return group ? group.open : false
    },

    isPurchasePriceCurrencyIdJa(id) {
      // TODO 本当は共通method
      if (id === 0) {
        return true
      }
      return false
    },

    getProductQuantity(productQuantity, transactionType) {
      const ret = productQuantity.reduce((result, current) => {
        if (
          !transactionType ||
          Number(current.transactionType) === transactionType
        ) {
          return result + current.quantity
        }
        return result
      }, 0)
      return ret
    },
    getStorageProductStockAndMoving(storageIdNameList, rec) {
      return storageIdNameList.map((ele) => {
        const stock = rec.productStockQuantityInfo.filter(
          (product) => ele.value === product.storageId
        )

        const moving = rec.productMovingQuantityInfo.filter(
          (product) => ele.value === product.storageId
        )

        return {
          storageName: ele.label,
          stock: this.getProductQuantity(stock, null),
          moving: this.getProductQuantity(moving, null)
        }
      })
    },

    getProductListData(productId) {
      return this.productListData.find((p) => p.productId === productId)
    },

    setGroupNamesOpen(newVal) {
      this.groupNames = this.groupNames.map((data, index) => {
        data.open = newVal.find((val) => val === data.index) !== undefined
        return data
      })
    },

    changeInvalid(...args) {
      const [invalid] = args

      this.productListData = this.productListData.map((product) => {
        product.invalid = false
        if (invalid.find((ele) => ele === product.productId)) {
          product.invalid = true
        }
        return product
      })

      // 販売商品 無効
      this.$emit('change', false, this.productListData)
    },

    setCountInput(productId, oldVal, event) {
      const isExist = event ? true : false
      event = parseInt(event)
      if (Number.isNaN(event)) {
        if (isExist) alert(this.$t('common.input_number-alert'))
        event = null
      }
      // 5桁の数字
      else if (!String(event).match(/^[0-9]{0,5}$/)) {
        event = oldVal
      }
      this.getProductListData(productId).count = event
      this.$refs[`${productId}_count`].lazyValue = event
      this.$emit('change', false, this.productListData)
    },

    async changeHistoryProductMoves(isInit) {
      if (Object.keys(this.historyProductMoves).length > 0) {
        if (isInit) await this.init()
        // 履歴から設定時
        this.$emit('change', true, this.productListData)
      }
    }
  },

  watch: {
    openPanelIndex: function (val) {
      this.setGroupNamesOpen(val)
    },
    search: {
      deep: true,
      handler(newVal, oldVal) {
        this.init()
      }
    },

    historyProductMoves: {
      deep: true,
      async handler(newVal, oldVal) {
        this.changeHistoryProductMoves(true)
      }
    }
  }
}
